/**
 * Les petites règles de la langue de l'écran, partagées par tous les fichiers de mots : la
 * majuscule en tête, un mot repris au milieu d'une phrase, un nombre accordé, un petit nombre en
 * lettres. Sans rendu.
 */

/**
 * La majuscule en tête d'un texte de l'interface (retour 9 des testeurs, 2026-09-26 : des
 * majuscules partout). La première lettre seulement, le reste tel quel. Jamais sur ce que
 * l'utilisateur a écrit : un titre de bulle s'affiche comme il l'a tapé.
 */
export function majuscule(texte: string): string {
  return texte.charAt(0).toLocaleUpperCase('fr-FR') + texte.slice(1);
}

/** Un mot de ce vocabulaire repris au milieu d'une phrase (« J’ai 10 min, demi-journée ») : sans sa majuscule. */
export function auMilieu(mot: string): string {
  return mot.charAt(0).toLocaleLowerCase('fr-FR') + mot.slice(1);
}

/** « 3 choses », « 1 chose ». */
export function nChoses(combien: number): string {
  return combien === 1 ? '1 chose' : `${combien} choses`;
}

/** 0 et 1 au singulier, comme on le dit : « 0 étape faite », « 1 faisable ». */
export function accord(n: number, singulier: string, pluriel: string): string {
  return `${n} ${n > 1 ? pluriel : singulier}`;
}

/** Un petit nombre s'écrit en lettres (« huit dossiers »), un grand en chiffres (« 135 »). */
export function enLettres(n: number): string {
  const mots = ['zéro', 'une', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix'];
  return mots[n] ?? String(n);
}

/**
 * Combien de choses, au milieu d'une phrase : en lettres jusqu'à quatre (« deux choses »), en
 * chiffres au-delà (« 9 choses »). L'inventaire (« Il restait … dedans ») et le choix d'une
 * destination (« Elle part avec … qu’elle contient ») ; ce dernier met l'article devant un
 * nombre en chiffres (« les 6 choses »).
 */
export function motDeCompte(n: number, { lesDevantUnChiffre = false } = {}): string {
  const mots = ['zéro chose', 'une chose', 'deux choses', 'trois choses', 'quatre choses'];
  return mots[n] ?? `${lesDevantUnChiffre ? 'les ' : ''}${n} choses`;
}
